import {
  AssignUserRolesInput,
  CreateUserInput,
  RoleIdentity,
  UpdateUserInput, CreateProjectClientInput, ProjectClientOwnersInput
} from '@generated/auth';
import { Expose } from 'class-transformer';
import { User } from './user';

export class Worker extends User {
  adminId: string | undefined;
  //userAgentConfigurations: UserAgentConfig[] | undefined;
  @Expose() roles: Role[] | undefined;
  @Expose() isLogEnable: boolean | undefined;
  @Expose() isCaptureScreen: boolean | undefined;
  @Expose() onAppSwitching: boolean | undefined;
  @Expose() captureScreenInterval: number | undefined;
}
export class UserAgentConfig extends User {
  userId: boolean | undefined;
  businessId: boolean | undefined;
  @Expose() useUserConfiguration: boolean | undefined;
  @Expose() isLogEnable: boolean | undefined;
  @Expose() isCaptureScreen: boolean | undefined;
  @Expose() onAppSwitching: boolean | undefined;
  @Expose() captureScreenInterval: number | undefined;
}

export class Role {
  @Expose() id?: string | undefined;
  @Expose() name?: string | undefined;
}

export class AssignUserRoles implements AssignUserRolesInput {
  @Expose() id: string | undefined;
  businessId: string | undefined;
  @Expose() roles: string[] | undefined;
}

export class UpdateUser implements UpdateUserInput {
  businessId: any;
  @Expose() id: string;
  @Expose() firstName: string;
  @Expose() lastName: string;
}

export class CreateUser implements CreateUserInput {
  adminId: any;
  businessId: any;
  @Expose() email: string;
  @Expose() firstName: string;
  @Expose() lastName: string;
}
export class CreateProjectClient implements CreateProjectClientInput {
  adminId: any;
  businessId: any;
  @Expose() email: string;
  @Expose() firstName: string;
  @Expose() lastName: string;
  @Expose() clientIds: string[];
}
export class ProjectClientOwner implements ProjectClientOwnersInput {
  adminId: any;
  businessId: any;
  @Expose() clientId?: string;
  @Expose() addUsers?: string[];
  @Expose() removeUsers?: string[];

}
